export const getJWTPayload = <T = object>(token: string): T => {
  const jsonPayload = decodeURIComponent(window.atob(token.split('.')[1]));

  return JSON.parse(jsonPayload);
};
